import MapCard2 from './MapCard2'

export default MapCard2
